// Biblioteca de componentes UI do design system Pactua
// Origem: handoff Claude Design (design/pactua-2-ia-handoff.zip)
// Story: UI-1.2 (Onda 2 do Epic UI-1)
// Norma: docs/architecture/permission-model.md (não aplica)
// Ver: services/frontend/src/components/ui/README.md

export { default as Avatar } from './Avatar';
export type { AvatarColor, AvatarSize } from './Avatar';

export { default as AvatarStack } from './AvatarStack';

export { default as Button } from './Button';
export type { ButtonVariant, ButtonSize } from './Button';

export { default as Card } from './Card';

export { default as Chip } from './Chip';
export type { ChipVariant } from './Chip';

export { default as DataTable } from './DataTable';
export type { DataTableColumn } from './DataTable';

export { default as DocCircle } from './DocCircle';
export type { DocStatus } from './DocCircle';

export { default as PageTitle } from './PageTitle';

export { default as ProgressBar } from './ProgressBar';
export type { ProgressVariant } from './ProgressBar';

// Addon UI-1.2.5 (Story Acesso-1c.3): componentes admin.
export { default as Modal } from './Modal';
export { default as PdfViewerModal } from './PdfViewerModal';
export { default as DocInput } from './DocInput';
export { default as SearchInput } from './SearchInput';
export { default as FilterSelect } from './FilterSelect';

// Cont-4c (2026-04-25): componentes inline; serão extraídos para UI-1.5.
export { default as Banner } from './Banner';
export type { BannerVariant } from './Banner';

export { default as Timeline } from './Timeline';
export type { TimelineItem, TimelineItemStatus } from './Timeline';

export { default as ConfirmacaoDigitada } from './ConfirmacaoDigitada';

// cont-ui-2b (2026-05-05): Stepper genérico para fluxos guiados.
export { default as Stepper } from './Stepper';
export type { Step, StepStatus } from './Stepper';

// ia-cc-2 (epic IA custo-consciente): bloco padrão de análise IA (Modo A).
export { default as BlocoAnaliseIa } from './BlocoAnaliseIa';
export type { AnaliseIaEstado, BlocoAnaliseIaProps } from './BlocoAnaliseIa';

// Seleção com busca (combobox) — para listas grandes (ex.: modelos de IA).
export { default as SearchableSelect } from './SearchableSelect';
export type { SearchableOption, SearchableSelectProps } from './SearchableSelect';
